import { render, staticRenderFns } from "./CoursewareEmptyElementBox.vue?vue&type=template&id=c98f8cd6&"
import script from "./CoursewareEmptyElementBox.vue?vue&type=script&lang=js&"
export * from "./CoursewareEmptyElementBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/moritz/html/v5.3-jlu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c98f8cd6')) {
      api.createRecord('c98f8cd6', component.options)
    } else {
      api.reload('c98f8cd6', component.options)
    }
    module.hot.accept("./CoursewareEmptyElementBox.vue?vue&type=template&id=c98f8cd6&", function () {
      api.rerender('c98f8cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/vue/components/courseware/CoursewareEmptyElementBox.vue"
export default component.exports